import React from "react";
import { useTranslation } from "react-i18next";

function Pagination({ totalPages, currentPage, handlePageChange, children }) {
    const { t,i18n } = useTranslation("productlist");
    return (
        <div className="flex justify-center items-center mt-10">
            <button
                onClick={() => handlePageChange(currentPage - 1)}
                disabled={currentPage === 1}
                className={currentPage === 1 ? 'opacity-50 cursor-not-allowed' : ''}
            >
                {i18n.language === 'en' ? (
                    <img src="/arrow--left.svg" alt={t("pagination.alt.previous")} />
                ) : (
                    <img src="/arrow--right.svg" alt={t("pagination.alt.previous")} />
                )}
            </button>
            {children}
            <button
                onClick={() => handlePageChange(currentPage + 1)}
                disabled={currentPage === totalPages}
                className={currentPage === totalPages ? 'opacity-50 cursor-not-allowed' : ''}
            >
                {i18n.language === 'en' ? (
                    <img src="/arrow--right.svg" alt={t("pagination.alt.next")} />
                ) : (
                    <img src="/arrow--left.svg" alt={t("pagination.alt.next")} />
                )}
            </button>
        </div>
    );
}

export default Pagination;
